import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Text } from '../Typography/Text';

export interface IAvatarButton {
    isDisabled: boolean;
}

export const AvatarButton = styled(Link)<IAvatarButton>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 50%;
    border: none;
    overflow: hidden;
    ${({ theme, isDisabled }) => css`
        background: ${theme.colors.bgSecondary};
        transition: all ${theme.transitions.hover};
        cursor: ${isDisabled ? 'auto' : 'pointer'};
        &:hover {
            box-shadow: ${isDisabled ? 'none' : theme.boxShadow.primaryHover};
        }
    `};
`;

export const Initials = styled(Text)`
    color: white;
    transition: all ${({ theme }) => theme.transitions.hover};
`;
